<template>
  <div>
    <vue-headful title="Verdiensten" />
    <Header page_title="Verdiensten" />
    <div class="px-4 mx-2 pb-4 mt-4">
      <form @change="onFormChange" @submit.prevent="onSubmit" class="sd-form">
        <div class="container-fluid px-0 pb-1 mb-2">
          <NotificationContainer />
          <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="suitcase" /> Verdiensten</span></strong>
          <div class="sd-notif warning sd-alert" v-if="formDisabled">
            <svg-icon icon="information" class="warning-icon" />
            <div class="content">
              Je kunt hier zelf geen aanpassingen doen. Neem contact met ons op om veranderingen door te geven. <a href="mailto:info@derect.nl">info@derect.nl</a>.
              <div v-if="type == 0">
                Je kunt wel aanpassen of je loonheffingskorting wil toepassen of
                niet.
              </div>
            </div>
          </div>

          <div class="sd-custom worker-type custom-control custom-radio mt-3">
            <input
              type="radio"
              class="custom-control-input"
              id="temp_worker"
              value="0"
              v-model="type"
              :disabled="formDisabled"
            />
            <label for="temp_worker" class="custom-control-label"
              >Ik ben uitzendkracht</label
            >
          </div>
          <div class="sd-custom worker-type custom-control custom-radio">
            <input
              type="radio"
              class="custom-control-input"
              id="zzp"
              value="1"
              v-model="type"
              :disabled="formDisabled"
            />
            <label for="zzp" class="custom-control-label">Ik ben zzp'er</label>
          </div>

          <div v-if="this.branch == 1" class="sd-notif warning">
            <svg-icon icon="information" class="warning-icon" />
            Je ontvangt een reiskostenvergoeding van deur tot deur van €0,21 per
            kilometer, conform CAO Onderwijs.
          </div>
          <div v-else-if="this.branch == 2" class="sd-notif warning">
            <svg-icon icon="information" class="warning-icon"/>
            Je ontvangt een reiskostenvergoeding van deur tot deur van €0,21 per
            kilometer, conform CAO Kinderopvang.
          </div>
          <div v-if="type == '1' && branch == 1" class="sd-notif warning">
            <svg-icon icon="information" class="warning-icon"/>
            Voor de facturatie aan Derect dien je vrijgesteld te zijn van btw.
            Ben je dat (nog) niet, neem dan contact met ons op.
          </div>

          <div class="temp_worker" v-if="type == '0'">
            <div>
              <div class="mb-3" style="margin-top: 1.5rem !important">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="wallet" /> Kies hier je salaris/tarief</span></strong>
                </p>
              </div>

              <div class="mb-4">
                <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()" v-if="this.branch == 1">
                  <label>Schaal</label>
                  <select
                    class="custom-select form-control"
                    v-model="form_salary.salary_id"
                    required
                    :disabled="formDisabled"
                  >
                    <option value selected disabled>Schaal</option>
                    <option
                      v-for="option in this.salaries_temp"
                      :key="option.id"
                      :value="option.id"
                      >{{ option.name }}</option
                    >
                  </select>
                  <div class="icon-wrapper dropdown position-absolute align-self-center">
                    <svg-icon icon="chevron_s" />
                  </div>
                </div>

                <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                  <label>Trede / Tarief (excl. BTW)</label>
                  <select
                    class="custom-select form-control"
                    v-model="form_salary.years_experience"
                    required
                    :disabled="formDisabled"
                  >
                    <option value selected disabled
                      >Trede / Tarief (excl. BTW)</option
                    >
                    <option
                      v-for="year in years_temp_worker"
                      :value="year"
                      v-bind:key="year + `-years`"
                      >{{ year }}</option
                    >
                  </select>
                  <div class="icon-wrapper dropdown position-absolute align-self-center ">
                    <svg-icon icon="chevron_s" />
                  </div>
                </div>
                <template v-if="user.sub_branch == '1,2'">
                  <div class="input-row subbranch">
                    <div :class="'form-group sd-col-6 pb-1 sd-input ' + getDisabledClass()">
                      <label>Basisonderwijs salaris</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="EUR / uur"
                        v-model="salary_display"
                        readonly
                        :disabled="formDisabled"
                      />
                    </div>
                    <div :class="'form-group sd-col-6 pb-1 sd-input ' + getDisabledClass()">
                      <label>Voortgezet onderwijs salaris</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="EUR / uur"
                        v-model="salary_display_vo"
                        readonly
                        :disabled="formDisabled"
                      />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div :class="'form-group pb-1 ' + getDisabledClass()">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="EUR / uur"
                      v-model="salary_display"
                      readonly
                      :disabled="formDisabled"
                    />
                  </div>
                </template>
              </div>

              <div class="mb-3">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="creditcard" /> Jouw rekeningnummer</span></strong>
                </p>
              </div>

              <div class="form-group sd-input mb-4">
                <label>De tenaamstelling van je rekening</label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('account_name') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'De tenaamstelling van je rekening' +
                      [this.required.includes('account_name') ? ' *' : '']
                  "
                  v-model="form_temp.account_name"
                  @input="forceUpper($event, form, 'account_name')"
                  required
                  :disabled="formDisabled"
                />
              </div>
              <div class="form-group mb-4 sd-input mb-4">
                <label>IBAN</label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('account_number') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'IBAN' +
                      [this.required.includes('account_number') ? ' *' : '']
                  "
                  v-model="form_temp.account_number"
                  v-mask="'AA##AAAA##########'"
                  @input="forceUpper($event, form, 'account_number')"
                  required
                  :disabled="formDisabled"
                />
                <span class="extra-info" style="margin-bottom: 15px;">
                  <svg-icon icon="information" />
                  IBAN formaat: NL99BANK0123456789 (gebruik géén spaties)
                </span>
              </div>
            </div>
            <div class="mb-3">
              <p>
                <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="discount" /> Loonheffingskorting</span></strong>
              </p>
            </div>
            <div class="mb-4 position-relative">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  v-model="form_temp.income_tax"
                  v-bind:true-value="1"
                  v-bind:false-value="0"
                />
                <label class="custom-control-label apply-deduction" for="customSwitch1"
                  >Wil je loonheffingskorting toepassen?</label
                >
              </div>
              <a
                data-toggle="collapse"
                href="#collapseExample"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                <i class="material-icons-round">help</i>
              </a>
              <div class="collapse" id="collapseExample">
                <div class="alert alert-info mt-3 mb-1" role="alert">
                  <div class="small text-left">
                    Je kunt maar bij één werkgever de heffingskorting toepassen.
                    Doe dit bij de werkgever waar je het meest verdient. Als je
                    bij iedere werkgever loonheffingskorting aanvraagt, krijg je
                    namelijk te veel korting op je belasting. Je moet dan
                    achteraf extra belasting betalen.
                  </div>
                </div>
              </div>
              <div class="sd-notif warning" v-if="formDisabled">
                <svg-icon icon="information" class="warning-icon" />
                Ook als je al een salaris hebt doorgegeven kun je de
                loonheffingskorting aanpassen.
              </div>
            </div>
            <!-- <Required v-if="user" /> -->
            <button type="submit" class="btn btn-warning btn-block">
              Opslaan
            </button>
          </div>

          <div class="zzp" v-if="type == '1'">
            <div class="mb-3">
              <p>
                <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="office" /> Bedrijfsgegevens</span></strong>
              </p>
            </div>
            <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
<!--              <label>Bedrijfs type</label>-->
              <select
                class="custom-select form-control"
                v-model="form_kvk.legalform"
                required
                :disabled="formDisabled"
              >
                <option disabled value="">Selecteer één</option>
                <option>eenmanszaak</option>
                <option>VOF</option>
                <option>BV</option>
              </select>
              <div class="icon-wrapper dropdown position-absolute align-self-center ">
                <svg-icon icon="chevron_s" />
              </div>
            </div>
            <div class="form-group sd-input mb-4">
              <label>Tenaamstelling onderneming</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                v-bind:placeholder="
                  'Tenaamstelling onderneming' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                v-model="form_kvk.company_name"
                @input="forceUpper($event, form, 'account_name')"
                required
                :disabled="formDisabled"
              />
              <small class="form-text text-muted">
                Let op: de tenaamstelling kan geen leestekens bevatten
              </small>
            </div>
            <div class="form-group sd-input mb-4">
              <label>KVK-nummer</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                v-bind:placeholder="
                  'KVK-nummer' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                v-model="form_kvk.kvk"
                @input="forceUpper($event, form, 'account_name')"
                required
                :disabled="formDisabled"
              />
            </div>
            <div class="form-group mb-4 pb-1 sd-input mb-4">
              <label>BTW-nummer</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                v-bind:placeholder="
                  'BTW-nummer' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                v-model="form_kvk.btw"
                @input="forceUpper($event, form, 'account_name')"
                required
                :disabled="formDisabled"
              />
            </div>

            <div class="mb-3">
              <p>
                <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="wallet" /> Uurtarief</span></strong>
              </p>
            </div>

            <div class="mb-4">
              <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                <label>ZZP</label>
                <select
                  class="custom-select form-control"
                  v-model="form_salary.salary_id"
                  required
                  :disabled="formDisabled"
                >
                  <option v-if="this.branch == 1" :key="3" :value="3" selected>ZZP</option>
                  <option v-if="this.branch == 2" :key="14" :value="14" selected>ZZP</option>
                </select>
                <div
                  class="icon-wrapper dropdown position-absolute align-self-center"
                >
                  <svg-icon icon="chevron_s" />
                </div>
              </div>
              <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                <label>Trede / Tarief (excl. BTW)</label>
                <select
                  class="custom-select form-control"
                  v-model="form_salary.years_experience"
                  required
                  :disabled="formDisabled"
                >
                  <option value selected disabled
                    >Trede / Tarief (excl. BTW)</option
                  >
                  <option
                    v-for="year in years_zzp"
                    :value="year"
                    v-bind:key="year + `-years`"
                    >{{ year }}</option
                  >
                </select>
                <div
                  class="icon-wrapper dropdown position-absolute align-self-center"
                >
                  <svg-icon icon="chevron_s" />
                </div>
              </div>
              <div :class="'form-group pb-1 ' + getDisabledClass()">
                <input
                    type="text"
                    class="form-control"
                    placeholder="EUR / uur"
                    v-model="salary_display"
                    readonly
                    :disabled="formDisabled"
                />
              </div>
            </div>
            <div class="mb-3">
              <p>
                <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="creditcard" /> Jouw rekeningnummer</span></strong>
              </p>
            </div>

            <div class="form-group sd-input mb-4">
              <label>De tenaamstelling van je rekening</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                v-bind:placeholder="
                  'De tenaamstelling van je rekening' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                v-model="form_kvk.account_name"
                @input="forceUpper($event, form, 'account_name')"
                required
                :disabled="formDisabled"
              />
            </div>
            <div class="form-group sd-input mb-4">
              <label>IBAN</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="[
                  this.required.includes('account_number') ? 'require' : ''
                ]"
                v-bind:placeholder="
                  'IBAN' +
                    [this.required.includes('account_number') ? ' *' : '']
                "
                v-model="form_kvk.account_number"
                v-mask="'AA##AAAA##########'"
                @input="forceUpper($event, form, 'account_number')"
                required
                :disabled="formDisabled"
              />
              <small class="form-text text-muted">
                IBAN formaat: NL99BANK0123456789 (gebruik géén spaties)
              </small>
            </div>
            <button
              type="submit"
              class="btn btn-warning btn-block"
              v-if="!formDisabled"
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      branch: 0,
      sub_branch: '1',
      user: "",
      type: "",
      salaries_temp: null,
      form: {
        account_name: "",
        account_number: "",
        income_tax: 0
      },
      form_temp: {
        customer_type: 0,
        account_name: "",
        account_number: "",
        income_tax: 0
      },
      form_kvk: {
        customer_type: 1,
        legalform: "",
        kvk: "",
        btw: "",
        company_name: "",
        account_name: "",
        account_number: ""
      },
      form_salary: {
        salary_id: "",
        years_experience: "",
        salary_per_hour: null
      },
      salary_display: "EUR / uur",
      salary_display_vo: "EUR / uur",
      required: "",
      formDisabled: false,
      prevRoute: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    form_salary: {
      immediate: true,
      handler: function() {
        if (this.form_salary.salary_id && this.form_salary.years_experience) {
          this.computeSalary();
        } else if (this.branch == 2 && this.form_salary.years_experience) {
          this.computeSalary();
        }
      },
      deep: true
    }
  },
  computed: {
    years_temp_worker() {
      let ctr = 1;
      let last = 12;
      if (this.branch == 2) {
        ctr = 9;
        last = 21;
      }
      let arr = [];
      while (ctr <= last) {
        arr.push(ctr);
        ctr++;
      }
      return arr;
    },
    years_zzp() {
      let ctr = 1;
      let last = 15;
      if(this.sub_branch == '2' || this.sub_branch == '1,2') {
        last = 19;
      }
      else if (this.branch == 2) {
        last = 9;
      }
      let arr = [];
      while (ctr <= last) {
        arr.push(ctr);
        ctr++;
      }
      return arr;
    }
  },
  methods: {
    forceUpper(e, obj, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(obj, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
    async fetchData() {
      this.$store.state.loading = true;
      this.branch = localStorage.getItem("branch");
      this.sub_branch = localStorage.getItem("subBranch");
      this.user = JSON.parse(localStorage.getItem("user"));
      this.required = this.$store.state.applicant_fields;
      this.formDisabled =
        typeof this.user.account_name === "undefined" ||
        this.user.account_name === null ||
        this.user.account_name === ""
          ? false
          : true;
      this.salaries_temp = await this.getAPIList("salaries/" + this.branch);
      await this.autoFillForm();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        var obj;
        // const user = JSON.parse(localStorage.getItem("user"));
        // update the form obj from user
        if (this.user.customer_type === 0) {
          this.type = "0";
          for (obj in this.form_temp) {
            if (this.user[obj]) {
              this.form_temp[obj] = this.user[obj];
            }
          }
        } else {
          this.type = "1";
          for (obj in this.form_kvk) {
            if (this.user[obj]) {
              this.form_kvk[obj] = this.user[obj];
            }
          }
        }

        for (obj in this.form) {
          if (this.user[obj]) {
            this.form[obj] = this.user[obj];
          }
        }
        for (obj in this.form_salary) {
          if (this.user[obj]) {
            this.form_salary[obj] = this.user[obj];
          }
        }
        resolve();
      });
    },
    async updateUser() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        let formData = new FormData();
        var obj;
        if (this.type === "0") {
          for (obj in this.form_temp) {
            formData.append(obj, this.form_temp[obj]);
          }
        } else {
          for (obj in this.form_kvk) {
            formData.append(obj, this.form_kvk[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            if (this.formDisabled === true) {
              localStorage.removeItem("form-pending");
              const notification = {
                type: "success",
                message: "Je hebt je gegevens succesvol aangepast. "
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
            }
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async updateSalary() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/salary";
        let formData = new FormData();
        for (var obj in this.form_salary) {
          if (obj === "salary_id" && this.branch == 2 && this.type === "0") {
            formData.append(obj, 13);
          } else {
            formData.append(obj, this.form_salary[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(
          () =>
            this.$router.replace({
              name: this.prevRoute.name,
              params: this.prevRoute.params
            }),
          800
        );
      });
    },
    async onSubmit() {
      if (this.formDisabled === false) {
        this.$store.state.loading = true;
        window.scrollTo(0, 0);
        await this.updateUser();
        await this.updateSalary();
        // continue only if resolve()
        await this.updateLocalUser();
        await this.redirectBack();
        this.$store.state.loading = false;
      } else {
        this.$store.state.loading = true;
        window.scrollTo(0, 0);
        await this.updateUser();
        // continue only if resolve()
        await this.updateLocalUser();
        await this.redirectBack();
        this.$store.state.loading = false;
      }
    },
    async computeSalary() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/salary/compute";
        let formData = new FormData();
        if (this.branch == 2) {
          if (this.type == "0") {
            formData.append("salary_id", 13);
          } else {
            formData.append("salary_id", 14);
          }
        } else {
          formData.append("salary_id", this.form_salary.salary_id);
        }
        formData.append("years", this.form_salary.years_experience);

        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            let salary = resp.data.salary.replace(/\./g, ",");
            let voSalary = resp.data.salary_vo ? resp.data.salary_vo.replace(/\./g, ",") : "";

            if (this.type == 0)
            {
              this.salary_display = "EUR / uur: " + salary;
              this.salary_display_vo = "EUR / uur: " + voSalary;
            }
            else
            {
              this.salary_display = "EUR / uur: " + salary + " (excl. btw)";
              this.salary_display_vo = "EUR / uur: " + voSalary + " (excl. btw)";
            }

            this.form_salary.salary_per_hour = resp.data.salary;
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));

      if (this.type === "1") {
        if (this.branch == 1) {
          this.form_salary.salary_id = 3;
        } else {
          this.form_salary.salary_id = 14;
        }
      }
    },
    getDisabledClass() {
      return this.formDisabled ? "form-disabled" : "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.form-control[readonly] {
  background: #f5f4f4;
  opacity: 1;
}

.subbranch {
  font-weight: 500;
}

select[disabled] {
  opacity: 1;
}

.form-disabled {
  opacity: 0.5;
}

.custom-control-label.apply-deduction {
  display: inline-flex;
}

.custom-control-label.apply-deduction::before {
  margin-right: 10px;
}

.custom-checkbox .custom-control-label::before {
  top: 3px;
}
.custom-checkbox .custom-control-label::after {
  top: 3px;
}

.custom-switch + a {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

a.toggle-info {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: red;
}

.custom-switch + a i.material-icons-round {
  color: #FFCD00;
}
.custom-switch + a[aria-expanded="true"] i.material-icons-round {
  color: #c0bdbb;
}
</style>
